export interface RestorableAuthSession {
    hasTokenForUser(userSub: string): boolean;
    hasValidTokenForUser(userSub: string): boolean;
    refreshToken(): Promise<string>;
}

export const restoreAuthSessionForUser = async (
    authSession: RestorableAuthSession,
    userSub: string,
): Promise<boolean> => {
    if (!authSession.hasTokenForUser(userSub)) {
        return false;
    }

    if (authSession.hasValidTokenForUser(userSub)) {
        return true;
    }

    try {
        await authSession.refreshToken();
    } catch {
        return false;
    }

    return authSession.hasValidTokenForUser(userSub);
};
